import { colors } from '../../colors';
var para = {
  messageColor: colors.neonPurple
};
export default para;